import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';

import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { CustomerTypeService } from '../../../services/customer-type.service';
import { LocationService } from '../../../services/location.service';
import { PDAUserService } from '../../../services/pda-user.service';
import { NavigationEnd, Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { Customer_Type } from '../../../models/customer_Type';
import { DistributionReportService } from '../../../services/distribution-report.service';
import { PDAUser } from '../../../models/pda_User';
import { CheckUserType } from '../../../models/checkUserType';
import { ColumnService } from '../../../services/ColumnService';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-distribution-report',
  templateUrl: './distribution-report.component.html',
  styleUrls: ['./distribution-report.component.css']
})
export class DistributionReportComponent implements OnInit {
  role = new CheckUserType();
  client;

  companyService: CompanyService;
  locationService: LocationService;

  customerTypes: Customer_Type[];
  users: PDAUser[];

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];
  showCalendars: boolean = true;

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    location_Id: 0,
    pda_User_ID: 0,
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
    advanced_Search: false,
    quick_Search: ''
  };

  //Columns Shown By Default
  availableOptions: string[];
  availableOptionSet1: string[] = ['Date/Time', 'Date', 'Customer', 'Location Address', 'Postcode', 'Customer Type', 'User',
    'Opening Stock', 'Closing Stock', 'Collections', 'Deliveries', 'Faults'];
  availableOptionSet2: string[] = ['Date/Time', 'Date', 'Customer', 'Location Address', 'Postcode', 'Customer Type', 'User',
    'Opening Stock',
    'OS - 1L O2', 'OS - 1.7L O2', 'OS - 2L O2', 'OS - 2.5L O2', 'OS - 2.7L O2', 'OS - 3L O2', 'OS - 10L O2',
    'OS - 1L N', 'OS - 1.7L N', 'OS - 2L N', 'OS - 2.5L N', 'OS - 2.7L N', 'OS - 3L N', 'OS - 10L N',
    'Closing Stock',
    'CS - 1L O2', 'CS - 1.7L O2', 'CS - 2L O2', 'CS - 2.5L O2', 'CS - 2.7L O2', 'CS - 3L O2', 'CS - 10L O2',
    'CS - 1L N', 'CS - 1.7L N', 'CS - 2L N', 'CS - 2.5L N', 'CS - 2.7L N', 'CS - 3L N', 'CS - 10L N',
    'Collections',
    'C - 1L O2', 'C - 1.7L O2', 'C - 2L O2', 'C - 2.5L O2', 'C - 2.7L O2', 'C - 3L O2', 'C - 10L O2',
    'C - 1L N', 'C - 1.7L N', 'C - 2L N', 'C - 2.5L N', 'C - 2.7L N', 'C - 3L N', 'C - 10L N',
    'Deliveries',
    'D - 1L O2', 'D - 1.7L O2', 'D - 2L O2', 'D - 2.5L O2', 'D - 2.7L O2', 'D - 3L O2', 'D - 10L O2',
    'D - 1L N', 'D - 1.7L N', 'D - 2L N', 'D - 2.5L N', 'D - 2.7L N', 'D - 3L N', 'D - 10L N',
    'Faults']
  selectedOptions: string[] = ['Date', 'Customer', 'Location Address', 'Customer Type', 'User',
    'Opening Stock', 'Closing Stock', 'Collections', 'Deliveries', 'Faults'];

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  showPopup: boolean = false;
  popupContent: string = '';
  private routerEventsSubscription: Subscription;

  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService, pdaUserService: PDAUserService,
    public distributionReportService: DistributionReportService, customerTypeService: CustomerTypeService, public router: Router,
    private columnService: ColumnService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);
    
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";
    
    this.loadFiltersFromStorage();
    
    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });
    
    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;
      
      if (this.role.isStandard || this.role.isMasterStandard || this.role.isAdmin) {
        this.filter.company_Id = this.client.companyId;
      }
      
      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        if (this.filter.company_Id !== 0) {
          this.locations = this.locationList;
        }

      });

      this.loadTable(this.page);
    });

    this.companyService = companyService;
    this.locationService = locationService;

    pdaUserService.getAll().then((data) => {
      this.users = data;
    });
  }

  ngOnInit() {
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.saveFiltersToStorage();
      }
    });
    this.updateAvailableColumns();
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  ngOnDestroy() {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
    this.saveFiltersToStorage();
  }

  updateAvailableColumns() {
    this.availableOptions = this.filter.advanced_Search == 0 ? this.availableOptionSet1 : this.availableOptionSet2;
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }


  // ###################################
  // Filters
  // ###################################
  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
  
    this.companyService.getAll(value).then((companies) => {
      this.companyList = companies;
      this.companies = companies;
  
      this.locations = [];
    });
  }
  
  onCompanyChange(value) {
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
  
    if (Number(value) === 0) {
      this.locations = [];
      return;
    }
  
    this.locationService.getAll(value).then((locations) => {
      this.locationList = locations;
      this.locations = locations;
    });
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {

    if (!event.column.prop) {
      return false;
    }

    const sortMapping = {
      'starttime_Display': 'starttime_Sorting',
    };

    const sortOrder = event.newValue;
    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = sortOrder;
    this.page.sortBy = sortBy;

    this.loadTable(this.page);
  }


  loadTable(page: Page) {
    this.distributionReportService.getResults(this.page, this.filter.customer_Type_Id, this.filter.company_Id, this.filter.location_Id,
      this.filter.pda_User_ID, this.filter.start_Date, this.filter.end_Date, this.role.isStandard, this.filter.advanced_Search,
      this.filter.quick_Search).then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

loadAuditOpeningStockPage(row: any) {
  const url = this.router.createUrlTree(
    ['reports/distribution_report/audit_opening_stock_cyls'],
    {
      queryParams: {
        distribution_Id: row.distribution_ID,
        date: row.starttime_Display
      }
    }
  ).toString();

  // Open in a new tab
  window.open(url, '_blank');
}


 loadAuditClosingStockPage(row: any) {
  const url = this.router.serializeUrl(
    this.router.createUrlTree(
      ['reports/distribution_report/audit_chart'],
      {
        queryParams: {
          distribution_Id: row.distribution_ID
        }
      }
    )
  );
  // Open the constructed URL in a new tab
  window.open(url, '_blank');
}

loadCollectionsPage(row: any) {
  const url =
    this.router.serializeUrl(this.router.createUrlTree(['reports/distribution_report/collections_and_deliveries'], {
      queryParams: 
      {
        distribution_Id: row.distribution_ID,
        type: "C",
        date: row.starttime_Display
      }
    }
  )
);
window.open(url,'_blank');
}

  loadDeliveriesPage(row: any) {
    const url =
    this.router.serializeUrl(this.router.createUrlTree(['reports/distribution_report/collections_and_deliveries'], {
      queryParams: {
        distribution_Id: row.distribution_ID,
        type: "D",
        date: row.starttime_Display
      }
    }
  )
  );
  window.open(url,'_blank');
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.distributionReportService.getExcel(this.filter.customer_Type_Id, this.filter.company_Id, this.filter.location_Id,
      this.filter.pda_User_ID, this.filter.start_Date, this.filter.end_Date, this.role.isStandard).then((data) => {
        importedSaveAs(data, 'Distributions.xlsx');
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');

    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "distributionReport").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "distributionReport", this.selectedOptions).then((data) => {
    });
  }

  saveFiltersToStorage() {
    const savedState = {
      filter: this.filter,
      pageNumber: this.page.pageNumber
    };
    localStorage.setItem('distributionReportState', JSON.stringify(savedState));
  }

  loadFiltersFromStorage() {
    const savedState = localStorage.getItem('distributionReportState');
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      this.filter = parsedState.filter;
      this.page.pageNumber = parsedState.pageNumber || 0;
      this.filter.start_Date = moment(this.filter.start_Date).toDate();
      this.filter.end_Date = moment(this.filter.end_Date).toDate();
    }
  }

  resetFilters() {
    this.filter.customer_Type_Id = 0;
    this.filter.company_Id = 0;
    this.filter.location_Id = 0;
    this.filter.pda_User_ID = 0;
    this.filter.quick_Search = '';
    this.filter.advanced_Search = false;
    // Forcefully re-render date pickers
    this.showCalendars = false;
  
    setTimeout(() => {
      const today = moment().toDate();
      this.filter.start_Date = today;
      this.filter.end_Date = today;
  
      this.showCalendars = true;
    });
  
    localStorage.removeItem('distributionReportState');
    this.loadTable(this.page);
  }
}

